import { httpClient } from './http-client';

export default {
	sendRegistration(params) {
		return httpClient.post('/api/registration', params);
	}
};
